import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  picker: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#ddd',
    fontFamily: 'sans-serif',
    maxWidth:'100%',
    width: 400,
  },

  header: {
    padding: 16,
    color: '#2196f3',
    fontSize: 24,
  },

  timeRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    marginTop: 10,
    paddingHorizontal: 16,
  },

  wheelSlot: {
    flex: 1,
    maxWidth: 100,
  },

  separator: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#111',
    marginHorizontal: 4,
  },

  wheels: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    height: 220,
    overflow: 'hidden',
  },

  selection: {
    position: 'absolute',
    top: 90,
    left: 0,
    right: 0,
    height: 40,
    borderTopWidth: 2,
    borderTopColor: '#2196f3',
    borderBottomWidth: 2,
    borderBottomColor: '#2196f3',
    pointerEvents: 'none',
    zIndex: 10,
  },

  wheelColumn: {
    flex: 1,
    position: 'relative',
    overflow: 'hidden',
  },

  wheelTrack: {
    position: 'absolute',
    width: '100%',
  },

  wheelItem: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
    userSelect: 'none',
  },

  wheelItemActive: {
    color: '#111',
    fontWeight: 'bold',
    fontSize: 20,
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 20,
    paddingHorizontal: 16,
  },

  button: {
    flex: 1,
    height: 40,
    backgroundColor: '#3b82f6',
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    borderRadius: 10,
    borderWidth: 0,
    cursor: 'pointer',
  },
});
